import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { LogoMark } from "@/components/site/Logo";
import { FloatingMotifs } from "@/components/site/Motifs";
import { Seo } from "@/components/site/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/yonetim" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/yonetim");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="relative min-h-screen grid place-items-center bg-bej-light paper-grain px-4">
      <Seo title="Yönetici Girişi" />
      <FloatingMotifs />
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-[2rem] bg-white p-8 shadow-xl border border-bej space-y-5" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <LogoMark className="w-16 h-16" />
          <div>
            <h1 className="font-heading text-2xl font-black text-navy">Yönetim Paneli</h1>
            <p className="text-sm text-slate-500">Masal Sanat Akademi</p>
          </div>
        </div>
        <div>
          <label className="block text-sm font-bold text-navy mb-1.5">E-posta</label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-xl" required data-testid="admin-login-email" />
        </div>
        <div>
          <label className="block text-sm font-bold text-navy mb-1.5">Şifre</label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 rounded-xl" required data-testid="admin-login-password" />
        </div>
        {error && <p className="rounded-xl bg-rose-50 border border-rose-200 p-3 text-sm text-rose-700" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="w-full inline-flex justify-center items-center gap-2 rounded-full bg-navy py-3 font-heading font-bold text-white hover:bg-navy-dark transition-colors disabled:opacity-50">
          <Lock className="w-4 h-4" /> {busy ? "Giriş yapılıyor…" : "Giriş yap"}
        </button>
      </form>
    </div>
  );
}
